import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './PresentationDesign.module.css';
import daveImg from '../../images/DJ-hero.png';
import cmpImg from '../../images/cmp-hero.png';
import alzaferImg from '../../images/alzafar-hero.png';

const cards = [
  {
    id: 1,
    title: 'Dave Jenkins',
    subtitle: 'Motorsport Sponsorship Deck',
    description: 'A bold commercial presentation combining racing photography, clear data and structured sponsorship packages.',
    image: daveImg,
    route: '/ppt/dave-jenkins',
    tag: 'Sponsorship · 2026',
  },
  {
    id: 2,
    title: 'CMP Invester',
    subtitle: 'Investor Pitch Deck',
    description: 'A clean and compelling investor pitch deck designed to communicate vision, traction and growth strategy.',
    image: cmpImg,
    route: '/ppt/cmp-invester',
    tag: 'Pitch Deck · 2025',
  },
  {
    id: 3,
    title: 'Alzafer Hospital',
    subtitle: 'Healthcare Presentation',
    description: 'A professional healthcare presentation showcasing services, facilities and patient care excellence.',
    image: alzaferImg,
    route: '/ppt/alzafer-hospital',
    tag: 'Healthcare · 2025',
  },
];

const PresentationDesign = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      <div className={styles.page}>
        <div className={styles.bgOrb1} />
        <div className={styles.bgOrb2} />

        <section className={styles.hero}>
          <p className={styles.kicker}>Graphic Design</p>
          <h1 className={styles.title}>Presentation Design</h1>
          <p className={styles.subtitle}>Slides, Decks &amp; Pitch Presentations</p>
        </section>

        <section className={styles.grid}>
          {cards.map((card) => (
            <div
              key={card.id}
              className={`${styles.card} ${hovered === card.id ? styles.cardHovered : ''}`}
              onMouseEnter={() => setHovered(card.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => { window.scrollTo(0, 0); navigate(card.route); }}
            >
              <div className={styles.imageWrap}>
                <img src={card.image} alt={card.title} className={styles.image} />
                <div className={styles.overlay}>
                  <span className={styles.viewLabel}>View Project →</span>
                </div>
              </div>
              <div className={styles.cardBody}>
                <span className={styles.tag}>{card.tag}</span>
                <h2 className={styles.cardTitle}>{card.title}</h2>
                <p className={styles.cardSubtitle}>{card.subtitle}</p>
                <p className={styles.cardDesc}>{card.description}</p>
              </div>
            </div>
          ))}
        </section>
      </div>
      <Footer mode={mode} />
    </>
  );
};

export default PresentationDesign;
